import React, { memo } from 'react';
import { useDrag, useDrop } from 'react-dnd';
const DragWrapperTab = /*#__PURE__*/memo(_ref => {
  let {
    id,
    children,
    moveTab,
    findTab
  } = _ref;
  const originalIndex = findTab(id).index;
  const [, drag] = useDrag(() => ({
    type: 'TAB',
    item: {
      id,
      originalIndex
    },
    collect: monitor => ({
      isDragging: monitor.isDragging()
    })
  }), [id, originalIndex, moveTab]);
  const [, drop] = useDrop(() => ({
    accept: 'TAB',
    hover(_ref2) {
      let {
        id: draggedId
      } = _ref2;
      if (draggedId !== id) {
        const {
          index: overIndex
        } = findTab(id);
        moveTab(draggedId, overIndex);
      }
    }
  }), [findTab, moveTab]);
  return /*#__PURE__*/React.createElement("div", {
    key: id,
    ref: node => drag(drop(node)),
    className: "hoi-poi-ui__tabs-tab-draggable"
  }, children);
});
export default DragWrapperTab;